import { colors, typography } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const AccessTagStyled = styled.span<{ $size: 'small' | 'large' }>`
  ${typography.bold[12]}
  white-space: nowrap;
  background-color: ${colors.purple[100]};
  color: ${colors.purple[600]};
  border-radius: ${({ $size }): string => ($size === 'small' ? '4px' : '5px')};
  padding: ${({ $size }): string => ($size === 'small' ? '0.3rem 0.8rem' : '0.6rem 1rem')};
  border: 1px solid ${colors.purple[300]};
`;
